import type {
	WebRTCConnectionEventCallback,
	WebRTCTalkSignal,
	WebRTCTalkSignalCallback,
	WebRTCTrackEventCallback,
} from '../types/webrtc-events';

/**
 * Events handler for WebRTC connections.
 */
export class WebRTCEvents {
	onConnectionEvent: WebRTCConnectionEventCallback | null;
	onTrackEvent: WebRTCTrackEventCallback | null;
	onTalkState: WebRTCTalkSignalCallback | null;

	constructor(
		onConnectionEvent?: WebRTCConnectionEventCallback,
		onTrackEvent?: WebRTCTrackEventCallback,
		onTalkState?: WebRTCTalkSignalCallback,
	) {
		this.onConnectionEvent = onConnectionEvent || null;
		this.onTrackEvent = onTrackEvent || null;
		this.onTalkState = onTalkState || null;
	}

	registerConnectionEvent(callback: WebRTCConnectionEventCallback) {
		this.onConnectionEvent = callback;
	}

	triggerConnectionEvent(eventName: string, peerConnection: RTCPeerConnection, event: any) {
		if (this.onConnectionEvent) {
			this.onConnectionEvent(eventName, peerConnection, event);
		}
	}

	registerTrackEvent(callback: (e: RTCTrackEvent) => void) {
		this.onTrackEvent = callback;
	}

	triggerTrackEvent(e: RTCTrackEvent) {
		if (this.onTrackEvent) {
			this.onTrackEvent(e);
		}
	}

	registerTalkStateEvent(callback: WebRTCTalkSignalCallback) {
		this.onTalkState = callback;
	}

	triggerTalkStateChange(signal: WebRTCTalkSignal) {
		if (this.onTalkState) {
			this.onTalkState(signal);
		}
	}
}
